import * as fromRouter from '@ngrx/router-store';
import {ActionReducer, ActionReducerMap, createFeatureSelector, createSelector, MetaReducer} from '@ngrx/store';

import {environment} from '../../environments/environment';
import * as fromGlobalMessage from '../core/reducers/global-message.reducer';
import * as fromLayout from '../core/reducers/layout.reducer';

export interface State {
    router: fromRouter.RouterReducerState;
    layout: fromLayout.State;
    messages: fromGlobalMessage.State;
}


export const reducers: ActionReducerMap<State> = {
    router: fromRouter.routerReducer,
    layout: fromLayout.reducer,
    messages: fromGlobalMessage.reducer
};


export function logger(reducer: ActionReducer<State>) {
    return function (state, action) {
        console.log('state', state);
        console.log('action', action);
        return reducer(state, action);
    };
}

/**
 * storeFreeze prevents state from being mutated. When mutation occurs, an
 * exception will be thrown. This is useful during development mode to
 * ensure that none of the reducers accidentally mutates the state.
 *
 * adds logger and storeFreeze in dev mode
 */
export const metaReducers: MetaReducer<State>[] = !environment.production
    ? [logger] : [];

export const getLayoutState = createFeatureSelector<fromLayout.State>('layout');

export const getIsQuoteListOpen = createSelector(
    getLayoutState,
    (state: fromLayout.State) => state.isQuoteListOpen && !state.isSubmittedQuoteListOpen
);

export const getIsQuoteViewSelectionOpen = createSelector(
    getLayoutState,
    (state: fromLayout.State) => state.isQuoteViewSelectionOpen || state.isQuoteListOpen
);

export const getIsSubmittedQuoteListOpen = createSelector(
    getLayoutState,
    (state: fromLayout.State) => state.isSubmittedQuoteListOpen
);

export const getIsCreateNewQuoteMenuOpen = createSelector(
    getLayoutState,
    (state: fromLayout.State) => state.isCreateNewQuoteMenuOpen
);

export const getIsSiteMenuOpen = createSelector(
    getLayoutState,
    fromLayout.getIsSiteMenuOpen
);

export const getIsAdvancedSearchOpen = createSelector(
    getLayoutState,
    fromLayout.getIsAdvancedSearchOpen
);

export const getGlobalMessageState = createFeatureSelector<fromGlobalMessage.State>('messages');

export const getGlobalMessages = createSelector(getGlobalMessageState, fromGlobalMessage.selectAllMessages);

export const getIsSideNavOpen = createSelector(
    getIsSiteMenuOpen,
    getIsQuoteListOpen,
    getIsAdvancedSearchOpen,
    getIsQuoteViewSelectionOpen,
    (isSiteMenuOpen, isQuoteListOpen, isAdvancedSearchOpen, isQuoteViewSelectionOpen) => {
        return isSiteMenuOpen || isQuoteListOpen || isAdvancedSearchOpen || isQuoteViewSelectionOpen;
    }
);
